import(/* webpackMode: "eager" */ "/var/www/project/git/fe_bolsasocial_js/app/features/web/Header/webHeader.tsx")